export interface FrontendBuildInfo {
  commit: string;
  builtAt: string;
}

export interface BackendBuildInfo {
  versionId: string;
  tag: string | null;
  deployedAt: string;
}

export interface StagingBuildInfo {
  environment: "staging";
  backend: BackendBuildInfo;
}

export function isStagingBuildHost(hostname: string): boolean {
  return hostname === "staging.craftoff.io" || hostname.startsWith("craftoff-staging.");
}

export function shortBuildId(value: string): string {
  return value.slice(0, 8);
}

export function isStagingBuildInfo(value: unknown): value is StagingBuildInfo {
  if (!value || typeof value !== "object") return false;
  const candidate = value as Partial<StagingBuildInfo>;
  const backend = candidate.backend as Partial<BackendBuildInfo> | undefined;
  return candidate.environment === "staging"
    && typeof backend?.versionId === "string"
    && backend.versionId.length > 0
    && (backend.tag === null || typeof backend.tag === "string")
    && typeof backend.deployedAt === "string";
}
